module.exports = __webpack_public_path__ + "img/medicalStaff.aa0bc570.png";